<style lang="scss" >
.v-alert.error {
  background-color: #ef6868;
}
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
.v-speed-dial__list {
  width: 0;
  left: 14%;
}
.fullheight {
  height: 100vh;
}

/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
</style>

<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        router-link(:to='{ path: "/discount" }') Discount
        router-link(
          :to='{ name: "discount-list", params: { pdList: addpdList } }'
        ) {{ addpdList["name"] }}
        a Add product
  .row.fullheight
    .col.s12
      v-card
        v-card-title
          button.btn(
            v-if='selected.length !== 0',
            @click='saveProductDiscounted()'
          ) Add
          v-spacer
          v-text-field.custom-search.mb-0(
            v-model='search',
            append-icon='search',
            label='Search',
            single-line='',
            hide-details=''
          )
        v-data-table(
          v-model='selected',
          :search='search',
          :headers='headers',
          :items='mutableInventory.productVariants',
          item-key='variantCode',
          select-all=''
        )
          template(slot='items', slot-scope='props')
            td
              v-checkbox(v-model='props.selected', primary='', hide-details='')
            td {{ props.item.variantCode }}
            td {{ props.item.availableStock }}
          v-alert(
            slot='no-results',
            :value='true',
            color='red',
            icon='warning'
          )
            | Your search for &quot;{{ search }}&quot; found no results.
</template>
<script>
import DataTable from 'vue-materialize-datatable'

export default {
  data () {
    return {
      mutableInventory: {
        id: null,
        name: null,
        productVariants: []
      },
      search: '',
      selected: [],
      test_array: [0, 1, 2, 3, 5],
      pagination: {
        sortBy: 'name'
      },
      headers: [
        { text: 'Product Variant', value: 'variantCode', align: 'left' },
        { text: 'Available Stock', value: 'availableStock', align: 'left' }
        // { text: 'price', value: 'price', align: 'left' },
        // { text: 'sale', value: 'sale', align: 'left' }
        // { text: 'Actions', value: '', align: 'left' }
      ],
      // for fab
      direction: 'right',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition'
    }
  },
  computed: {
    activeFab () {
      switch (this.tabs) {
        case 'one':
          return { class: 'purple', icon: 'account_circle' }
        case 'two':
          return { class: 'red', icon: 'edit' }
        case 'three':
          return { class: 'green', icon: 'keyboard_arrow_up' }
        default:
          return {}
      }
    },
    addpdList () {
      return this.$route ? this.$route.params.addpdList : null
    },
    inventoryID () {
      return this.$route ? this.$route.params.inventoryID : null
    },
    supplier () {
      return this.$store.state.profile.supplier
    },
    discountedProduct () {
      var formatted = []
      for (var i = 0; i < this.selected.length; i++) {
        formatted[i] = {
          discountId: this.addpdList['id'],
          productVariantId: this.selected[i]['id']
        }
      }
      return formatted
    }
  },
  mounted () {
    this.getInventoryContents()
  },
  methods: {
    getInventoryContents () {
      if (!this.supplier) {
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories/${this.inventoryID[0]['inventory']['id']}`,
            {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.mutableInventory = result.data
          })
      })
    },
    saveProductDiscounted () {
      let data = this.discountedProduct
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .post(
            `${this.$config.API_URL}/suppliers/discount/add-discounted-product`,
            data,
            {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.$snackbar.success('Product/s Successfully Added')
            let params = {
              pdList: this.addpdList
            }
            this.$router.push({ name: 'discount-list', params: params })
          })
      })
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.discountList.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  },
  filters: {
    convert: function (value) {
      return value.toFixed(2)
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-discount-addproduct.vue